export default "__VITE_ASSET__B4xbybz8__"